/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CatalogRecommendationDto
 */
export interface CatalogRecommendationDto {
    /**
     * 
     * @type {string}
     * @memberof CatalogRecommendationDto
     */
    packSlug?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogRecommendationDto
     */
    packKind?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogRecommendationDto
     */
    displayName?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogRecommendationDto
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogRecommendationDto
     */
    capabilityDomain?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogRecommendationDto
     */
    frameworkSlug?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CatalogRecommendationDto
     */
    coversControlIds?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof CatalogRecommendationDto
     */
    coverageCount?: number;
    /**
     * 
     * @type {number}
     * @memberof CatalogRecommendationDto
     */
    coverageRatio?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof CatalogRecommendationDto
     */
    packTotalControlIds?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CatalogRecommendationDto
     */
    alreadyInstalled?: boolean;
}

/**
 * Check if a given object implements the CatalogRecommendationDto interface.
 */
export function instanceOfCatalogRecommendationDto(value: object): value is CatalogRecommendationDto {
    return true;
}

export function CatalogRecommendationDtoFromJSON(json: any): CatalogRecommendationDto {
    return CatalogRecommendationDtoFromJSONTyped(json, false);
}

export function CatalogRecommendationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CatalogRecommendationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'packSlug': json['packSlug'] == null ? undefined : json['packSlug'],
        'packKind': json['packKind'] == null ? undefined : json['packKind'],
        'displayName': json['displayName'] == null ? undefined : json['displayName'],
        'description': json['description'] == null ? undefined : json['description'],
        'capabilityDomain': json['capabilityDomain'] == null ? undefined : json['capabilityDomain'],
        'frameworkSlug': json['frameworkSlug'] == null ? undefined : json['frameworkSlug'],
        'coversControlIds': json['coversControlIds'] == null ? undefined : json['coversControlIds'],
        'coverageCount': json['coverageCount'] == null ? undefined : json['coverageCount'],
        'coverageRatio': json['coverageRatio'] == null ? undefined : json['coverageRatio'],
        'packTotalControlIds': json['packTotalControlIds'] == null ? undefined : json['packTotalControlIds'],
        'alreadyInstalled': json['alreadyInstalled'] == null ? undefined : json['alreadyInstalled'],
    };
}

export function CatalogRecommendationDtoToJSON(json: any): CatalogRecommendationDto {
    return CatalogRecommendationDtoToJSONTyped(json, false);
}

export function CatalogRecommendationDtoToJSONTyped(value?: CatalogRecommendationDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'packSlug': value['packSlug'],
        'packKind': value['packKind'],
        'displayName': value['displayName'],
        'description': value['description'],
        'capabilityDomain': value['capabilityDomain'],
        'frameworkSlug': value['frameworkSlug'],
        'coversControlIds': value['coversControlIds'],
        'coverageCount': value['coverageCount'],
        'coverageRatio': value['coverageRatio'],
        'packTotalControlIds': value['packTotalControlIds'],
        'alreadyInstalled': value['alreadyInstalled'],
    };
}

